import { render, staticRenderFns } from "./OrderRemarks.vue?vue&type=template&id=aa953b1c"
import script from "./OrderRemarks.vue?vue&type=script&lang=js"
export * from "./OrderRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports